import React, { useState, useContext, useEffect } from "react";
import { Router, RouterProvider, createBrowserRouter } from "react-router-dom";

import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { digitsEnToFa, addCommas } from "persian-tools";

import AppLayout from "./codes/appLayout";
import ProductPage from "./codes/Products";
import AppContext from "./codes/context";

import "./App.css";
import "./fontiran.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

function App() {
  const [select, setSelected] = useState(false);
  const [organizationData, setOrganizationData] = useState({});
  const [organizationIsloading, setOrganizationIsloading] = useState(true);
  const [productsData, setProductsData] = useState({ data: [{}, {}, {}, {}] });
  const [productsIsLoading, setProductsIsLoading] = useState(true);
  // fields=*,images.*
  useEffect(function () {
    async function fetchData() {
      const res = await fetch(
        `https://binesh-motahar.liara.run/items/articles?fields=*,image.*&filter[status][_eq]=published`
      );
      const data = await res.json();

      setProductsData(data);
      setProductsIsLoading(false);
    }
    async function fetchOrganizationData() {
      const res = await fetch(
        `https://binesh-motahar.liara.run/items/binesh/1`
      );
      const data = await res.json();
      setOrganizationData(data);
      setOrganizationIsloading(false);
    }
    fetchOrganizationData();
    fetchData();
  }, []);

  const router = createBrowserRouter([
    {
      element: (
        <AppContext.Provider
          value={{
            organizationData,
            organizationIsloading,
          }}
        >
          <AppLayout />
        </AppContext.Provider>
      ),
      children: [
        {
          path: "/",
          element: (
            <AppContext.Provider
              value={{
                select,
                onSelect: setSelected,
                productsData,
                organizationData,
                productsIsLoading,
                organizationIsloading,
              }}
            >
              <div className="main">
                <Header />
                {select ? <Products /> : <Introduction />}
              </div>
            </AppContext.Provider>
          ),
        },
        {
          path: "/articles/:Id",
          element: (
            <AppContext.Provider
              value={{
                productsData,
                productsIsLoading,
              }}
            >
              <ProductPage />
            </AppContext.Provider>
          ),
        },
      ],
    },
  ]);
  return <RouterProvider router={router} />;
}

function Header() {
  return (
    <header>
      <ImageSlider />

      <div className="switch">
        <TabButton text={"معرفی"} id={false} />
        <TabButton text={"مقالات"} id={true} />
      </div>
    </header>
  );
}
function ImageSlider() {
  const [slideData, setSliderData] = useState({ data: [{}, {}, {}] });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(function () {
    setIsLoading(true);
    async function fetchData() {
      const res = await fetch(`https://binesh-motahar.liara.run/items/slider`);
      const data = await res.json();
      setSliderData(data);
      setIsLoading(false);
    }
    fetchData();
  }, []);

  return (
    <Swiper
      slidesPerView={1.25}
      spaceBetween={8}
      centeredSlides={true}
      freeMode={true}
      loop={false}
      initialSlide={1}
      autoplay={{
        delay: 3000,
        disableOnInteraction: true,
      }}
      modules={[Autoplay, Pagination, Navigation]}
      style={{ backgroundColor: "var(--gray-white)" }}
    >
      {slideData.data.map((data) => (
        <SwiperSlide>
          {!isLoading ? (
            <a href={"data.link"}>
              <img
                alt={"slider"}
                src={`https://binesh-motahar.liara.run/assets/${data.image}`}
                className="slideImage"
              />
            </a>
          ) : (
            <div className="slideImage loading"></div>
          )}
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
function TabButton({ text, id }) {
  const { select, onSelect } = useContext(AppContext);

  return (
    <button
      className={` m-500 tabButton + ${id === select ? "select" : ""}`}
      onClick={() => (!id ? onSelect(false) : onSelect(true))}
    >
      {text}
    </button>
  );
}

function Product({ item }) {
  const { productsIsLoading } = useContext(AppContext);

  return (
    <div className="product">
      {!productsIsLoading ? (
        <a href={`${window.location.origin}/articles/${item.id}`}>
          <img
            alt="product"
            src={`https://binesh-motahar.liara.run/assets/${item.image.id}`}
            className="image"
          />
        </a>
      ) : (
        <div className="image loading"></div>
      )}

      <p className="text m-700" style={{ marginTop: "8px" }}>
        {!productsIsLoading ? item.title : "عنوان مقاله"}
      </p>

      <p className="text m-400-13" style={{ marginTop: "8px" }}>
        {!productsIsLoading
          ? item.description.slice(0, 50) + " ..."
          : "متن مقاله"}
      </p>
    </div>
  );
}

function Products() {
  const { productsData } = useContext(AppContext);

  return (
    <ul className="products">
      {productsData.data.map((item) => (
        <Product key={item.id} item={item} />
      ))}
    </ul>
  );
}

function Introduction() {
  const { organizationData, organizationIsloading } = useContext(AppContext);

  return (
    <div className="introduction">
      <p className="text l-500">
        معرفی {!organizationIsloading ? organizationData.data.name : "مجموعه"}
      </p>
      <p className="text m-400" style={{ padding: "16px 0 16px 0" }}>
        {!organizationIsloading ? organizationData.data.description : ""}
      </p>
      <div className="text">
        <Button
          text={`کانال ایتا`}
          value={!organizationIsloading ? organizationData.data.eitaa : ""}
          key={1}
        />

        <button className="button  m-400 ">{`شماره تماس : ${
          !organizationIsloading ? organizationData.data.phoneNumber : ""
        }`}</button>
        <button className="button  m-400 ">{`ایمیل :  ${
          !organizationIsloading ? organizationData.data.email : ""
        }`}</button>
      </div>
    </div>
  );
}

function Button({ text, value }) {
  return (
    <a href={value} target="_blank" rel="noopener noreferrer">
      <button className="button  m-400 ">{text}</button>
    </a>
  );
}

export default App;
